<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-26 11:34:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-07-19 15:45:37
-->
<script lang='ts' setup>
import { APP_ROUTER, checkLink, imageTransform } from '@qctsw/common'
import topicSwiper from '../components/swiper.vue'
import red_block from '../components/red_block.vue'
import gridImage from '../components/gridImage.vue'
import brand from '../components/brand.vue'
import topicCard from '../components/topicCard.vue'
import tabPageData from '../components/tabPageData.vue'
import { type LocationShowCodeEnum, type OtherArticle, type PastTopic, REDBLACKLABEL, type TemplateTypeCode, type TopicArticleBase, type TopicTemplateNewsItem } from '~/server/types'
import { topicTemplateBaseDataApi } from '@/server'
import { LOAD_STATE } from '~/shared/types'

const props = defineProps<{ topicId: string, templateTypeCode: TemplateTypeCode, bodyJson: Record<string, any> }>()


const topicData = reactive<{

  pastTopics: PastTopic[]
  otherArticle: OtherArticle[]
  redTop: ({ content: string } & TopicArticleBase)[]
  blackTop: ({ content: string } & TopicArticleBase)[]
}>({

      pastTopics: [],
      otherArticle: [],
      redTop: [],
      blackTop: [],
    })

async function getData() {
  const loadState = ref(LOAD_STATE.INIT)
  const res = await useLoadState({
    state: loadState,
    key: 'topicTemplateBaseDataApi',
    fn: () => topicTemplateBaseDataApi({
      topicId: props.topicId,
      templateTypeCode: props.templateTypeCode as 2,
    }),
  })
  const baseData = res!.data

  topicData.pastTopics = baseData.pastTopics
  topicData.redTop = baseData.redTop
  topicData.blackTop = baseData.blackTop
  // REDBLACKLABEL
}

await getData()
</script>

<template>
  <div
    class="flex box flex-col w-full items-center pb-10"
  >
    <div class="w-full">
      <img w-full :src="imageTransform(bodyJson?.div_0?.topCoverImg, {})">
    </div>
    <div w-1200px mt-3>
      <topicSwiper :topic-id="topicId" />
      <topicCard v-if="topicData.redTop.length && topicData.blackTop.length" default-class="title_line" :title="bodyJson?.div_1?.title || '资讯'">
        <div gap-5 flex>
          <div
            v-for="item, index in (bodyJson?.div_1?.children || []).sort((a, b) => -a.locationShowCode + b.locationShowCode) " :key="index" :style="{
              '--color': REDBLACKLABEL[item.locationShowCode].color,
            }"
          >
            <red_block

              :list="topicData[REDBLACKLABEL[item.locationShowCode].key]"
              :title="REDBLACKLABEL[item.locationShowCode].label"
              :class=" `w-1/${(bodyJson?.div_1?.children || []).length}` "
            />
          </div>
        </div>
      </topicCard>
      <div class="flex w-full my-2">
        <div class="list  w-[calc(100%-380px)] pr-10">
          <tabPageData :template-type-code="2" :topic-id="topicId" :tab-list="(bodyJson?.div_2 || [])" />
        </div>
        <div w-380px overflow-hidden>
          <topicCard default-class="title_line" :title="bodyJson?.div_3?.title || '推荐专题'">
            <gridImage :to-page="APP_ROUTER.topicDetail" :template-type-code="2" :list="topicData.pastTopics" />
          </topicCard>
        </div>
      </div>
    </div>
    <div>
      <topicCard default-class="title_line" :title="bodyJson?.div_4?.title || '诚信品牌'">
        <brand :list="bodyJson.div_4.children"  />
      </topicCard>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.box {
  background-color: var(--bodyBg);
}
</style>
